import { createSetting, useDialog } from '@shopex/finder'
import { MessageBox } from 'element-ui'
import { deleteSetting, updateSetting } from '../api'

export const tableSetting = (vm) => createSetting({
  columns: [
    {
      name: '银联配置名称',
      key: 'name',
      minWidth: 150
    },
    {
      name: '所在地区',
      key: 'area_name',
      minWidth: 150,
      render: (h, { row }) => {
        return row.area_name
      }
    },
    {
      name: '关联经销商',
      key: 'dealer_name',
      minWidth: 150,
    },
    {
      name: '经销商HQID',
      key: 'dealer_hqid',
      minWidth: 150,
    },
  ],
  actions: [
    {
      name: '编辑',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          useDialog(null, {
            title: `编辑银联商务配置`,
            width: '50%',
            orgData: rows[0],
            component: () => import('../comps/create.vue'),
            actions: [
              { label: '取消', key: 'close', size: 'default' },
              { label: '提交', key: 'save', type: 'primary', size: 'default' }
            ]
          }).then(async (arg) => {
            if(arg) {
              console.log(arg, 'edit_arg')
              await updateSetting(arg).then(() => {
                vm.$message.success('修改成功')
                vm.refresh()
              })
            }
          })
        }
      }
    },
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          MessageBox.confirm('请确认是否删除当前数据？', '提示').then(async () => {
            const id = rows[0].id
            await deleteSetting(id)
            vm.$message.success('删除成功')
            vm.refresh()
          })
        }
      }
    },
  ]
})
